import type { SceneSection } from './manifest';
import { useScene } from './scene-context';
import { RitualSection } from './sections/RitualSection';
import { SaptapadiPheras } from './sections/SaptapadiPheras';

interface Props {
  section: SceneSection;
}

export function SceneSectionShell({ section }: Props) {
  const { pack } = useScene();
  // Indo-Ghibli, Storybook 3D, and Pichwai/Rajasthani Royal render their own bespoke presentation layout for Act V (Saat Phere)
  if (
    pack.id === 'indo_ghibli' ||
    pack.id === 'storybook_3d' ||
    pack.id === 'pichwai_heritage' ||
    pack.id === 'heritage'
  ) {
    return <RitualSection section={section} />;
  }
  if (section.ritualId === 'saptapadi') {
    return <SaptapadiPheras section={section} />;
  }
  return <RitualSection section={section} />;
}

